import axios from 'axios';
import { getAccessToken } from 'Helpers/session';
import { isEmpty, isNil, omitBy } from 'lodash';
import errorHandler from 'Utils/error-handler';
import normalizer from 'Utils/normalizer';

export type FetchQuotationFilters = {
  _id: string,
};
export const fetchQuotation = async (
  data: FetchQuotationFilters,
) => {
  const url = `${process.env.API_URL}/${process.env.API_VER}/quotation/fetch`;
  const accessToken = getAccessToken();

  try {
    const response = await axios({
      method: 'POST',
      url: url,
      data: omitBy(data, isNil, ),
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return response.data?.quotation ? normalizer.response.quotation(response.data.quotation) : null;
  } catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await fetchQuotation(data);
      const callbackResponse = await errorHandler.response(error, { callback });
      if (Array.isArray(callbackResponse)) return callbackResponse;

      const { value, code, message, stack } = callbackResponse;
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};
